import React from 'react'
import cn from 'classnames'
import CopyTooltip from 'components/shared/CopyTooltip'
import { showTooltipConfirmation } from 'state/imperativeApis/tooltipApi'
import { insertToClipboard } from 'utils'

export default function CopyLinkButton({
    getPublicLink,
    isMobile = false,
    styles = /** @type {Record<string, string>} */ ({}),
    tooltip = false,
    showLabel = true,
    testId = undefined,
}) {
    const showConfirmationTooltip = (tipped, confirmationText = 'Copied!', tooltipText) => {
        showTooltipConfirmation(tipped.current, {
            content: confirmationText,
            restoreContent: tooltipText,
            duration: isMobile ? 1000 : 2000,
            closeAfter: isMobile,
        })
    }

    const tooltipText = 'Copy Treechat Link'
    const tipped = React.createRef()
    const iconClass = 'fa fa-link'

    const mobileAnswerBtn = isMobile ? styles.mobileAnswerBtn : null

    const inner = (
        <div
            className={cn(styles.answerBtn, mobileAnswerBtn)}
            data-testid={testId}
            onClick={async ev => {
                ev.preventDefault()
                ev.stopPropagation()
                const publicLink = await getPublicLink(ev)
                insertToClipboard(publicLink)
                showConfirmationTooltip(tipped, 'Copied!', tooltipText)
            }}
        >
            <i className={iconClass}></i>

            {showLabel && (
                <span className={cn('control-label', styles.controlLabel)}>copy link</span>
            )}
        </div>
    )

    return (
        <div className={cn(styles.answerControl, 'copy-link-button-comp')}>
            {tooltip ? (
                <div className="copy-button-comp">
                    <CopyTooltip tip={tooltipText} offset={0} ref={tipped}>
                        {inner}
                    </CopyTooltip>
                </div>
            ) : (
                inner
            )}
        </div>
    )
}
